import { render, staticRenderFns } from "./storehouse.vue?vue&type=template&id=3937c2b1"
import script from "./storehouse.vue?vue&type=script&lang=js"
export * from "./storehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports